import { useEffect, useRef } from 'react';
import { useGameStore } from './store/gameStore';
import Lobby from './components/Lobby/Lobby';
import CharacterSelect from './components/CharacterSelect/CharacterSelect';
import GameBoard from './components/GameBoard/GameBoard';

export default function App() {
  const phase = useGameStore(s => s.phase);
  const isGame = phase === 'playing' || phase === 'gameOver';
  const guardActive = useRef(false);

  // ====== 浏览器返回手势历史守卫（在 isGame 变为 true 时立即执行，早于 GameBoard 渲染）======
  useEffect(() => {
    if (!isGame || guardActive.current) return;
    guardActive.current = true;

    // 用 replaceState 替换当前历史条目（消除 Lobby 页快照），再 push 一个，
    // 两次返回手势都留在当前游戏页，不会预览 Lobby 页
    window.history.replaceState({ _gameGuard: true }, '');
    window.history.pushState({ _gameGuard: true }, '');

    const onPopState = (e: PopStateEvent) => {
      // 拦截返回，推回 guard 状态
      window.history.pushState({ _gameGuard: true }, '');
      // 用 custom event 通知 GameBoard 显示退出确认
      window.dispatchEvent(new CustomEvent('game:exit-request'));
    };
    window.addEventListener('popstate', onPopState);

    // 防止横向滑动触发浏览器返回/前进预览
    const prevBodyX = document.body.style.overscrollBehaviorX;
    const prevHtmlX = document.documentElement.style.overscrollBehaviorX;
    document.body.style.overscrollBehaviorX = 'none';
    document.documentElement.style.overscrollBehaviorX = 'none';

    return () => {
      window.removeEventListener('popstate', onPopState);
      document.body.style.overscrollBehaviorX = prevBodyX;
      document.documentElement.style.overscrollBehaviorX = prevHtmlX;
      guardActive.current = false;
    };
  }, [isGame]);

  // ====== 游戏页禁止滚动（用 overscroll-behavior 替代 position:fixed，避免破坏浏览器手势动画）======
  useEffect(() => {
    const root = document.getElementById('root');
    if (!root) return;

    if (isGame) {
      root.classList.add('no-scroll');
      // 用 overscroll-behavior: contain 替代 position:fixed，防止橡皮筋效果但保留浏览器的正常手势动画
      document.body.style.overflow = 'hidden';
      document.body.style.overscrollBehavior = 'contain';
      document.documentElement.style.overscrollBehavior = 'contain';
    } else {
      root.classList.remove('no-scroll');
      document.body.style.overflow = '';
      document.body.style.overscrollBehavior = '';
      document.documentElement.style.overscrollBehavior = '';
    }

    return () => {
      document.body.style.overflow = '';
      document.body.style.overscrollBehavior = '';
      document.documentElement.style.overscrollBehavior = '';
    };
  }, [isGame]);

  return (
    <div style={{
      width: '100%',
      height: '100%',
      background: 'var(--bg-primary)',
      position: 'relative',
      overflow: isGame ? 'hidden' : 'visible',
    }}>
      {phase === 'lobby' && <Lobby />}
      {phase === 'characterSelect' && <CharacterSelect />}
      {isGame && <GameBoard />}
    </div>
  );
}
